import { AM_PM_TIME_SPACE_UPPERCASE_FORMAT_NO_LEADING_ZERO, MONTH_DAY_YEAR_FORMAT } from '@/config/variables';

const defaultFolderHome = {
  clientId: -1,
  folderId: -1,
  folderType: 'home',
} as const;

const resourceDateFormat = `${MONTH_DAY_YEAR_FORMAT} ${AM_PM_TIME_SPACE_UPPERCASE_FORMAT_NO_LEADING_ZERO}`;

const RESOURCE_ITEMS_PAGE_SIZE = 7;
const RECENT_ITEMS_TO_SHOW_CLIENT_SECTION = 5;
const LATEST_ITEMS_DAYS_BACK_THRESHOLD = 30;

export {
  defaultFolderHome,
  resourceDateFormat,
  RESOURCE_ITEMS_PAGE_SIZE,
  RECENT_ITEMS_TO_SHOW_CLIENT_SECTION,
  LATEST_ITEMS_DAYS_BACK_THRESHOLD,
};
